<template>
    <div>
        <div class="text-center" style="flex-direction: row;">
            <h4><b>Dependentes</b></h4>
            <md-button :disabled="privcodigo != 14 && privcodigo != 16" @click="openCadastro(cliente)" class="md-primary" style="">
                Cadastrar Novo
            </md-button>
            <h5 v-if="privcodigo != 14 && privcodigo != 16">Novos cadastros devem ser solicitados a um usuário com privilégio "Financeiro"</h5>
        </div>
        <table v-if="dependentesArr.length != 0">
            <tr>
                <th>CNPJ/CPF</th>
                <th>Inscrição Estadual</th>
            </tr>
            <tr v-for="(a, i) in dependentesArr" :key="i">
                <td>{{ a.CLIDEPCNPJ }}</td>
                <td>
                    <div
                        style="display: flex; flex-direction: row; justify-content: space-between;align-items: center;">
                        {{ a.CLIDEPIE }}
                        <v-btn :disabled="privcodigo != 14 && privcodigo != 16" color="#ff6658" class="ma-2 white--text" small fab @click="deletaDependente(a)">
                            <v-icon dark>close</v-icon>
                        </v-btn>
                    </div>
                </td>
            </tr>
        </table>
        <div>
            <cadastro @success="() => {
                showCadastro = false;
                msg = 'Sucesso!';
                this.getData(this.cliente);
            }" @cancel="(e) => {
    showCadastro = false;
}" :cliente="cliente" :open="showCadastro" />
        </div>
    </div>
</template>
<script>

import * as Clientes from "../../providers/clientes.service";
import cadastro from "./Dependentes/cadastro";

var jwt = require("jsonwebtoken");

export default {
    props: ["cliente"],
    components: {
        cadastro
    },
    data() {
        return {
            dependentesArr: [],
            showCadastro: false,
            privcodigo: 0
        };
    },
    created() {
        debugger
        var fUser = jwt.decode(localStorage.getItem("token"));

        this.privcodigo = fUser.PRIVCODIGO;

        this.getData(this.cliente);
    },
    methods: {
        getData(cliente) {
            debugger
            var self = this;
            Clientes.listaDependentes({ CLICODIGO: cliente.CLICODIGO }).then(
                r => {
                    self.dependentesArr = r.Rows;
                }
            );
        },
        openCadastro(cliente) {
            this.showCadastro = true;
        },
        deletaDependente(cliente) {
            if (confirm("Confirma a exclusão do dependente?") == true) {
                Clientes.deletaDependente(cliente)
                    .then(() => {
                        this.getData(this.cliente);
                    });
            }
        }
    }
};
</script>
<style>
table {
    width: 100%;
}

td,
th {
    border: 1px solid rgb(233, 233, 233);
    text-align: left;
    padding: 8px;
}

tr:nth-child(even) {
    background-color: #CFDFE5;
}
</style>